import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import LambdaApiService from '../../../services/apiService/lambda';
import { mapGetters, mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import has from 'lodash/has';
import isEqual from 'lodash/isEqual';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import { getColumnSize } from '../../../utils/bridgeUtils';
export default {
  name: 'CoreConnectorsCreateDialog',
  components: {
    codemirror: codemirror
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      },
      connectorId: parseInt((this.$route.params || {}).id) || null,
      selectedAccount: null,
      accounts: [],
      connector: {},
      bridgeValidation: {},
      bridgeTypes: [],
      lastSavedBridge: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), mapState('authentication', ['tenantId'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    canSave: function canSave() {
      return this.connector.type !== null && this.connector.name && (this.selectedAccount || {}).id;
    },
    hasConnectionDataError: function hasConnectionDataError() {
      return get(this.bridgeValidation, 'data.length', 0) > 0;
    }
  }),
  watch: {
    isOpen: function isOpen(newVal) {
      if (newVal) {
        this.setupNewConnector();
      }
    },
    'connector.type': {
      handler: function handler(newVal) {
        var _this = this;

        var bridgeTypesItem = this.bridgeTypes.find(function (config) {
          return config.type === newVal;
        });

        if (bridgeTypesItem !== undefined && has(bridgeTypesItem.manifest, 'templates') && bridgeTypesItem.manifest.templates.length > 0) {
          bridgeTypesItem.manifest.templates.forEach(function (item) {
            if (item.default === true) {
              _this.connector.config.parser.script = item.name;
            } else {
              _this.connector.config.parser.script = bridgeTypesItem.manifest.templates[0].name;
            }
          });
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.fetchAccounts();
    this.loadData().then(function () {
      _this2.setupNewConnector();
    }).catch(function (error) {
      console.error(error);

      _this2.$snack('Error loading data', 'error');
    });
  },
  methods: {
    get: get,
    getColumnSize: getColumnSize,
    setupNewConnector: function setupNewConnector() {
      this.bridgeValidations = {};
      this.connector = {
        name: this.$i18n_t('accMgmt.tenant.bridges.newBridge'),
        type: null,
        bridge: {
          config: {}
        },
        config: {
          parser: {}
        }
      };
    },
    fetchAccounts: function fetchAccounts() {
      var _this3 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this3.accounts = accounts;
      }).catch(function (error) {
        console.error(error);

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    loadData: function loadData() {
      var _this4 = this;

      this.isLoadingConnectors = true;
      this.bridgeTypes = [];
      this.bridges = [];
      return Promise.all([this.loadBridgeTypes(), this.loadBridgeConfigs(), this.loadTenantModules()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
            types = _ref2[0],
            configs = _ref2[1],
            tenantModules = _ref2[2];

        _this4.bridgeTypes = types.map(function (type) {
          return _objectSpread(_objectSpread({}, type), {}, {
            name: get(type, 'manifest.displayName')
          });
        }).sort(function (b1, b2) {
          if (b1.name > b2.name) {
            return 1;
          }

          if (b1.name < b2.name) {
            return -1;
          }

          return 0;
        });
        var wmBusModule = tenantModules.find(function (m) {
          return m.key === 'wMBus';
        });
        var wmBusModuleEnabled = wmBusModule ? wmBusModule.isEnabled : false;

        if (!wmBusModuleEnabled) {
          _this4.bridgeTypes = _this4.bridgeTypes.filter(function (bridge) {
            return bridge.type !== 'bridge-wireless-mbus-decoder';
          });
        }

        _this4.bridges = configs.map(function (config) {
          var bridgeType = _this4.bridgeTypes.find(function (t) {
            return t.type === config.type;
          });

          config.displayName = bridgeType ? get(bridgeType, 'manifest.displayName') : '';
          return config;
        });

        if (_this4.$route.query.showBridges !== undefined) {
          _this4.scrollBridgesIntoView();
        }
      }).catch(function (error) {
        console.error(error);

        _this4.$snack(_this4.$i18n_t('Common.errorLoadingData'), 'error');
      }).finally(function () {
        _this4.isLoadingConnectors = false;
      });
    },
    loadBridgeTypes: function loadBridgeTypes() {
      return ApiService.getBridgeTypes();
    },
    loadBridgeConfigs: function loadBridgeConfigs() {
      return ApiService.getBridgesForTenant(this.$route.params.account || this.tenantId);
    },
    bridgeConfigIsInbound: function bridgeConfigIsInbound(bridge) {
      return get(bridge, 'manifest.functionScope.invokeDirection.inbound', false);
    },
    bridgeConfigIsOutbound: function bridgeConfigIsOutbound(bridge) {
      return get(bridge, 'manifest.functionScope.invokeDirection.outbound', false);
    },
    bridgeConfig: function bridgeConfig(bridge) {
      return this.bridgeTypes.find(function (config) {
        return config.type === bridge.type;
      });
    },
    loadTenantModules: function loadTenantModules() {
      return ApiService.tenantFetchModules(this.tenantId);
    },
    bridgeConfigKeys: function bridgeConfigKeys(instance) {
      var bridgeManifest = this.bridgeConfig(instance).manifest;
      var keys = Object.keys(bridgeManifest.config[0]).filter(function (key) {
        if (get(bridgeManifest, "config[0][".concat(key, "].hidden"))) {
          return false;
        } // if field is readonly, only show if it has a value


        if (get(bridgeManifest, "config[0][".concat(key, "].readonly"))) {
          return !!instance.bridge.config[key];
        }

        var visibleConfig = get(bridgeManifest, "config[0][".concat(key, "].visible")) || {};
        return Object.keys(visibleConfig).every(function (dependentKey) {
          return instance.bridge.config[dependentKey] === visibleConfig[dependentKey];
        });
      });
      return keys.sort(function (a, b) {
        var orderIdxA = get(bridgeManifest, "config[0][".concat(a, "].orderIdx")) || 0;
        var orderIdxB = get(bridgeManifest, "config[0][".concat(b, "].orderIdx")) || 0;

        if (orderIdxA < orderIdxB) {
          return -1;
        }

        if (orderIdxA > orderIdxB) {
          return 1;
        }

        return a.localeCompare(b);
      });
    },
    bridgeHasValidParameters: function bridgeHasValidParameters() {
      var strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var currentParameters = get(this.connector, 'bridge.config');
      var savedParameters = get(this.lastSavedBridge, 'bridge.config');
      return !get(this.bridgeValidation, 'error', strict ? true : !isEqual(currentParameters, savedParameters));
    },
    changedBridgeParams: function changedBridgeParams() {
      this.bridgeValidation = {};
    },
    shouldShowTemplateSelect: function shouldShowTemplateSelect(bridgeInstance) {
      var bridgeConfig = this.bridgeConfig(bridgeInstance);
      var templates = bridgeConfig.manifest.templates || [];
      return bridgeConfig.manifest.functionScope.invokeDirection.inbound && (templates.length > 1 || bridgeConfig.manifest.functionScope.editableMutator);
    },
    editConfigMutator: function editConfigMutator(bridge) {
      if (bridge.bridge.mutator) {
        delete bridge.bridge.mutator;
        this.bridgeValidation = cloneDeep(this.bridgeValidation);
        return;
      }

      var template = this.bridgeConfig(bridge).manifest.templates.find(function (template) {
        return template.name === bridge.config.parser.script;
      });
      bridge.bridge.mutator = get(template, 'mutator.script');
      bridge.bridge = cloneDeep(bridge.bridge);
      this.bridgeValidation = cloneDeep(this.bridgeValidation);
    },
    refreshForm: function refreshForm() {
      var _this5 = this;

      setTimeout(function () {
        // required workaround to get the cursor appearing at the right spot
        // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
        _this5.$refs['codemirror'][0].codemirror.refresh();

        _this5.$refs['codemirror'][0].codemirror.focus();
      }, 50);
    },
    onCmFocus: function onCmFocus() {
      this.refreshForm();
      this.cmOptions.lineNumbers = true;
    },
    validateConnector: function validateConnector() {
      var _this6 = this;

      var scriptToEval = this.connector.bridge.mutator;
      var promiseValidate = ApiService.validateBridge(this.connector.type, this.connector.id, this.connector.bridge.config);
      var promiseEvalMutator = scriptToEval ? LambdaApiService.evaluateScript({
        script: scriptToEval,
        scriptParams: [{}]
      }) : Promise.resolve({});
      Promise.all([promiseValidate, promiseEvalMutator]).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            validationResult = _ref4[0],
            mutatorResult = _ref4[1];

        var bridgeInstance = _this6.connector;

        var bridgeManifest = _this6.bridgeConfig(bridgeInstance).manifest;

        if (get(bridgeManifest, 'functionScope.validator.returnsConfig')) {
          // (parts of) the config is returned/calculated for this bridge-validator,
          // so overwrite/merge with the existing config
          bridgeInstance.bridge.config = _objectSpread(_objectSpread({}, bridgeInstance.bridge.config), validationResult.data);
        }

        var errorMessage = get(validationResult, 'errorMessage', get(mutatorResult, 'error'));
        _this6.bridgeValidation = validationResult;
        _this6.connector.hasError = true;

        if (mutatorResult.syntaxError) {
          _this6.bridgeValidation = _objectSpread(_objectSpread({}, mutatorResult), {}, {
            mutatorScriptError: true
          });
        }

        if (errorMessage) {
          _this6.$snack(errorMessage, 'error');
        } else {
          _this6.persistBridge();
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    persistBridge: function persistBridge() {
      var _this7 = this;

      var persistPromise = Promise.resolve();

      if (this.connector.id) {
        persistPromise = ApiService.updateBridge(this.connector.id, this.connector);
      } else {
        persistPromise = ApiService.createBridge(this.selectedAccount.id, this.connector.type, this.connector);
      }

      return persistPromise.then(function (persistedBridge) {
        _this7.connector = persistedBridge;
        _this7.lastSavedBridge = persistedBridge;

        _this7.$snack(_this7.$i18n_t('Connectors.Connectors.saveSuccess'), 'success');

        _this7.$emit('close', true);
      }).catch(function (error) {
        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this7.$snack("".concat(error.response.data.message), 'error');
        }
      });
    },
    resetBridgeState: function resetBridgeState() {
      var _this8 = this;

      ApiService.resetBridgeState(this.connector.id, 'waiting').then(function (persistedBridge) {
        _this8.connector = persistedBridge;
      }).catch(function (error) {
        console.error(error);

        _this8.$snack(error, 'error');
      });
    }
  }
};